// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style__wrapper__mmVBW","reportBodyText":"style__reportBodyText__z8zhb"};